import React, { useContext } from "react";
import { Card, CardMedia } from "@mui/material";
import { GlobalContext } from "../../contexts/GlobalContext";

const Crest = ({ size = 100 }) => {
  const { globalContext, answeredCorrectly, maxGuessesUsed } =
    useContext(GlobalContext);

  return (
    <Card
      sx={{
        maxWidth: "100%", // Responsive width
        width: `${size}px`, // Set width based on the size prop
        margin: "0 auto", // Center the card
      }}
    >
      <CardMedia
        component="img"
        sx={{
          width: "100%", // Ensure the image takes up the full width of the card
          height: "auto", // Maintain aspect ratio
        }}
        image={
          answeredCorrectly || maxGuessesUsed
            ? globalContext.currentCrest.imageUrl
            : globalContext.currentCrest.greyscaleImage
        }
        alt={globalContext.currentCrest.clubName}
      />
    </Card>
  );
};

export default Crest;
